// extracted by mini-css-extract-plugin
export var container = "_2n-0";
export var error = "_2n-9";
export var label = "_2n-5";
export var light = "_2n-6";
export var md = "_2n-3";
export var sm = "_2n-2";
export var thin = "_2n-8";
export var thinBold = "_2n-7";
export var vertical = "_2n-4";
export var xs = "_2n-1";